(function(root){
 function linePrice(product,quantity){
  const qty=Math.max(1,Math.min(99,Math.floor(Number(quantity)||1)));
  const unit=Math.round(product.price*100),discountedUnit=Math.round(unit*88/100);
  const discountedQuantity=product.tripleOffer&&qty>=3?qty:0;
  const original=unit*qty,total=discountedUnit*discountedQuantity+unit*(qty-discountedQuantity);
  return {quantity:qty,unit,discountedUnit,discountedQuantity,original,total,saving:original-total};
 }
 root.SANTUREL_PRICING={linePrice};
 if(typeof module!=='undefined')module.exports={linePrice};
})(typeof window==='undefined'?globalThis:window);
